import { TextField } from "@mui/material";
import { useArbitrageFilters } from "src/Modules/Arbitrage/context";
import { FilterCatalogItem } from "src/Modules/Arbitrage/types";
import { useEffect, useMemo, useState } from "react";
import { EditFilterActions } from "../EditFilterActions";

export const GenericTextField = ({
  currentEditFilter,
  filterName,
}: {
  currentEditFilter: FilterCatalogItem;
  filterName: string;
}) => {
  const [value, setValue] = useState<any>();
  const { activeFiltersByName } = useArbitrageFilters();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const prevValue = useMemo(
    () => activeFiltersByName[filterName],
    [filterName, activeFiltersByName]
  );

  useEffect(() => {
    prevValue && setValue(prevValue);
  }, [prevValue]);

  return (
    <>
      <TextField
        autoFocus
        value={value}
        onChange={handleChange}
        id={currentEditFilter?.name}
        label={currentEditFilter?.displayName}
        variant="outlined"
        size="small"
        type={currentEditFilter?.type}
      />
      <EditFilterActions editValue={value} />
    </>
  );
};
